class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.addEventListener('click', (event) => {
        if (event.target.id === 'CartDrawer-Overlay') this.close();
      });
    this.setHeaderCartIconAccessibility();

    subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
      if (this.classList.contains('active')) {
        this.triggerShippingThresholdEvent();
      }
    });

    const params = new URLSearchParams(window.location.search);

    if (params.get("show_cart") === "1") {
      const cartDrawer = document.querySelector("cart-drawer");
      this.open();
      history.replaceState(null, "", window.location.pathname);
    }
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');

    this.syncKameleoon();
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  async syncKameleoon() {
    try {
      window.Kameleoon?.API?.Events?.trigger?.('open_cart_drawer');
    } catch (e) {
      console.error('[Kameleoon] Failed to trigger event:', e);
    }

    await this.triggerShippingThresholdEvent();

    try {
      const api = window.Kameleoon?.API?.Experiments;
      const idsEl = document.getElementById('checkout_experiment_ids');
      if (!api || !idsEl) return;

      const names = JSON.parse(idsEl.textContent || '[]');
      // console.log('[Kameleoon] Looking for experiment names:', names);

      const active = api.getActive?.() || [];
      // console.log('[Kameleoon] Active experiments from server:', active);

      const simulations = active.filter(exp => exp.id === -1);
      // console.log('[Kameleoon] Simulation entries (id: -1):', simulations);

      const realExperimentsByName = new Map(
        active.filter(exp => exp.id !== -1).map(exp => [exp.name.trim().toLowerCase(), exp])
      );

      const expMap = Object.fromEntries(
        names.map(name => {
          const normalizedName = name.trim().toLowerCase();
          const realExp = realExperimentsByName.get(normalizedName);
          const simulation = simulations.find(sim => sim.name.trim().toLowerCase() === normalizedName);

          if (!simulation && !realExp) {
            // console.log(`[Kameleoon] Skipping experiment "${name}": not active and no simulation`);
            return null;
          }

          const dataSource = simulation || realExp;

          const variationName = dataSource.associatedVariation?.name ?? 'Reference';
          const numberMatch = variationName.match(/\d+/);

          // console.log(`[Kameleoon] Experiment "${name}":`, {
          //   variationName,
          //   variationId: dataSource.associatedVariation?.id,
          //   fullVariation: dataSource.associatedVariation,
          //   usingSimulation: !!simulation,
          //   realExpActive: !!realExp
          // });

          return [
            dataSource.id,
            {
              name: name,
              variation: numberMatch ? `${name} variation ${numberMatch[0]}` : `${name} original`,
              variationId: dataSource.associatedVariation?.id ?? 0
            }
          ];
        }).filter(entry => entry !== null)
      );

      // console.log('[Kameleoon] Processed experiments:', expMap);
      if (Object.keys(expMap).length === 0) return;
      const expJson = JSON.stringify(expMap);
      // console.log('[Kameleoon] Writing to cart attribute:', expJson);

      const cartStateEl = document.getElementById('kameleoon-cart-state');
      const currentValue = cartStateEl ? JSON.parse(cartStateEl.textContent || '{}') : {};
      const currentJson = JSON.stringify(currentValue);

      if (currentJson === expJson) {
        return;
      }

      await fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          attributes: { 'kameleoon-checkout-experiments': expJson }
        })
      });

      if (cartStateEl) {
        cartStateEl.textContent = expJson;
      }
    } catch (error) {
      console.error('[Kameleoon] Error syncing cart attribute:', error);
    }
  }

  async triggerShippingThresholdEvent() {
    try {
      const country = this.dataset.country || '';
      const customerTags = (this.dataset.customerTags || '').split(',').filter(Boolean);
      const shipping = await co2.shippingData(country, customerTags);
      const threshold = shipping.campaignThreshold || shipping.standardThreshold;
      if (threshold && shipping.sub_total < threshold) {
        window.Kameleoon?.API?.Events?.trigger?.('open_cart_shipping_threshold_not_reached');
      }
    } catch (e) {
      console.error('[Kameleoon] Failed to trigger shipping-threshold event:', e);
    }
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems { }

customElements.define('cart-drawer-items', CartDrawerItems);
